import { gql } from '@/apollo';

export const GET_TRACE_SNAPSHOT_BY_HASH = gql(`
  query GetTraceSnapshotByHash($hash: String!) {
    traceSnapshotByHash(hash: $hash) {
      data
      meta
      nextActions
      tasks
      notifications
    }
  }
`);
